import React, { useState } from 'react'
import { Mail, ArrowRight } from 'lucide-react'

const Hero: React.FC = () => {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email) return

    setIsLoading(true)
    try {
      const { subscribeEmail } = await import('../utils/api')
      const result = await subscribeEmail(email)
      setMessage(result.message)
      
      if (result.success) {
        setEmail('')
      }
    } catch (error) {
      setMessage('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-600 to-primary-800 text-white">
      <div className="absolute inset-0 bg-black/10"></div>
      
      <div className="relative z-10 container-width section-padding text-center">
        <div className="max-w-4xl mx-auto animate-fade-in">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            AI 최전선의 진짜 트렌드
            <br />
            <span className="text-yellow-300">5분 핵심 요약</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-12 text-blue-100 font-light leading-relaxed">
            글로벌 AI 커뮤니티의 최신 인사이트를
            <br />
            매주 요약 전달합니다
          </p>

          <div className="max-w-md mx-auto mb-8">
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4">
              <div className="flex-1">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="이메일을 입력하세요"
                  className="input-field text-gray-900 placeholder-gray-500"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={isLoading}
                className="btn-primary bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-bold whitespace-nowrap flex items-center justify-center gap-2 min-w-[140px]"
              >
                {isLoading ? (
                  <div className="w-5 h-5 border-2 border-gray-900/30 border-t-gray-900 rounded-full animate-spin"></div>
                ) : (
                  <>
                    무료 구독하기
                    <ArrowRight className="w-4 h-4" />
                  </>
                )}
              </button>
            </form>
            
            {message && (
              <p className={`mt-4 text-sm ${message.includes('완료') || message.includes('성공') ? 'text-green-300' : 'text-red-300'}`}>
                {message}
              </p>
            )}
          </div>

          <div className="flex items-center justify-center gap-2 text-blue-200">
            <Mail className="w-5 h-5" />
            <span className="text-sm">무료 구독 • 언제든 취소 가능</span>
          </div>
        </div>
      </div>

      {/* 배경 장식 */}
      <div className="absolute top-20 left-20 w-32 h-32 bg-white/5 rounded-full blur-xl"></div>
      <div className="absolute bottom-20 right-20 w-48 h-48 bg-yellow-300/10 rounded-full blur-2xl"></div>
    </section>
  )
}

export default Hero
